import { render, staticRenderFns } from "./modal-recipient-input-numbers.vue?vue&type=template&id=1ba1fd52&"
import script from "./modal-recipient-input-numbers.vue?vue&type=script&lang=js&"
export * from "./modal-recipient-input-numbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports